import React from 'react';

import { Typography } from '@/ux-common/components/typography/typography';

interface SettingsSaveStatusMessageProps {
  hasPendingSave: boolean;
  allSucceeded: boolean;
  saveComplete: boolean;
  failedCount: number;
  cancelledCount: number;
}

export const SettingsSaveStatusMessage = ({
  hasPendingSave,
  allSucceeded,
  saveComplete,
  failedCount,
  cancelledCount,
}: SettingsSaveStatusMessageProps): React.ReactNode => {
  if (hasPendingSave) {
    return (
      <Typography as="p" className="text-body-base text-ckds-text-fg-tier3">
        Saving changes...
      </Typography>
    );
  }

  if (allSucceeded) return null;

  if (saveComplete && (failedCount > 0 || cancelledCount > 0)) {
    const parts: string[] = [];
    if (failedCount > 0) parts.push(`${failedCount} change(s) failed to save.`);
    if (cancelledCount > 0) parts.push(`${cancelledCount} change(s) cancelled.`);
    return (
      <Typography as="p" className="text-body-base text-ckds-text-fg-tier3">
        {parts.join(' ')}
      </Typography>
    );
  }

  return (
    <Typography as="p" className="text-body-base text-ckds-text-fg-tier3">
      Review each change before saving.
    </Typography>
  );
};
